import { Component } from '@angular/core';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

export interface RefreshColumnHeaderParams {
    refreshCallback: () => void;
}

@Component({
    selector: 'wdx-ag-grid-refresh-header',
    imports: [WdxIconModule],
    templateUrl: './refresh-column-header.component.html',
    host: {
        class: 'd-flex h-100 w-100 align-content-center justify-content-center pointer',
    },
})
export class RefreshColumnHeaderComponent implements IHeaderAngularComp {
    public params!: IHeaderParams & RefreshColumnHeaderParams;

    agInit(params: IHeaderParams & RefreshColumnHeaderParams): void {
        this.params = params;
    }

    refresh(params: IHeaderParams) {
        return false;
    }

    refreshClick() {
        this.params.refreshCallback();
    }
}
